import tailwindConfig from '@brewlogix/blx-ui/tailwind.constants.json'
import { propertyByString } from 'src/util/helpers'

export const parseLiquidColorSlug = (slug = '') => {
    const colorOptions = tailwindConfig.theme.colors
    let hexColor = null
    if (slug.includes('-')) {
        const fillColorArr = slug.split('-')
        if (fillColorArr[0] === 'srm') {
            fillColorArr[1] = String(parseInt(slug[1]) > 40 ? 40 : slug[1])
        }
        hexColor = propertyByString(colorOptions, fillColorArr.join('.'))
    } else {
        hexColor = colorOptions[slug]
    }
    return hexColor
}
